export const HERO_IMAGE = {
  url: "https://images.unsplash.com/photo-1607357910286-1ff94ac13c24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
  alt: "Kinetic luxury couple embrace in lush botanical conservatory",
};

export const HERO_STATS = [
  "420+ Weddings",
  "28 Countries",
  "Vogue & Harper's Bazaar Featured",
];

export const MARQUEE_ITEMS = [
  "Lake Como",
  "Provence",
  "Kyoto",
  "Amalfi Coast",
  "Highlands",
  "Paris",
  "Aspen",
  "Capri",
  "Santorini",
];

export const MANIFESTO = [
  {
    number: "01",
    title: "The Medium Format Soul",
    text: "Every frame is treated with medium format dynamic range. Grain is not noise; it is the tactile memory of a fleeting afternoon.",
  },
  {
    number: "02",
    title: "Unobtrusive Choreography",
    text: "We observe like documentary filmmakers and compose like Renaissance painters. No rigid staging; only effortless authenticity.",
  },
  {
    number: "03",
    title: "Heirloom Preservation",
    text: "Your day is preserved as high-fidelity archival artbooks and 4K cinema negatives curated to outlive trends.",
  },
];

export const GALLERY_CATEGORIES = ["All", "Weddings", "Engagements", "Portraits", "Editorial"];

export const GALLERY = [
  {
    id: "wed-1",
    category: "Weddings",
    title: "Villa Balbiano Whispers",
    location: "Lake Como, Italy",
    aspect: "aspect-[4/3]",
    span: "md:col-span-7",
    url: "https://images.pexels.com/photos/39352696/pexels-photo-39352696.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    story: "Golden hour shafts piercing vaulted Tuscan stone corridors as vows were spoken in absolute solitude.",
  },
  {
    id: "wed-2",
    category: "Weddings",
    title: "Cathedral Veil & Nocturne",
    location: "Aix-en-Provence, France",
    aspect: "aspect-[4/3]",
    span: "md:col-span-5",
    url: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
    story: "An archival study in monochrome movement and wild olive foliage.",
  },
  {
    id: "port-1",
    category: "Portraits",
    title: "The Chiaroscuro Bride",
    location: "Venice, Italy",
    aspect: "aspect-[3/4]",
    span: "md:col-span-4",
    url: "https://images.unsplash.com/photo-1492175742197-ed20dc5a6bed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBicmlkZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
    story: "Caravaggio lighting caressing layers of Belgian lace and delicate calla lilies.",
  },
  {
    id: "eng-1",
    category: "Engagements",
    title: "Highland Dawn Encounter",
    location: "Isle of Skye, Scotland",
    aspect: "aspect-[3/4]",
    span: "md:col-span-4",
    url: "https://images.unsplash.com/photo-1614929511547-974944a54c92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxjb3VwbGUlMjBlbmdhZ2VtZW50JTIwZW1icmFjZXxlbnwwfHx8fDE3OTAwNTA0OTV8MA&ixlib=rb-4.1.0&q=85",
    story: "Windswept amber meadows captured on medium format 120 film at first frost.",
  },
  {
    id: "edit-1",
    category: "Editorial",
    title: "Architectural Geometry & Satin",
    location: "Barcelona Pavilion, Spain",
    aspect: "aspect-[3/4]",
    span: "md:col-span-4",
    url: "https://images.unsplash.com/flagged/photo-1578317767641-c2a23b16b814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBicmlkZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
    story: "Brutalist shadow diagonals intersecting the sublime softness of bias-cut silk.",
  },
  {
    id: "eng-2",
    category: "Engagements",
    title: "Solitary Steppe Embrace",
    location: "Alentejo, Portugal",
    aspect: "aspect-[4/3]",
    span: "md:col-span-6",
    url: "https://images.unsplash.com/photo-1726766406089-0308c800b6b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxjb3VwbGUlMjBlbmdhZ2VtZW50JTIwZW1icmFjZXxlbnwwfHx8fDE3OTAwNTA0OTV8MA&ixlib=rb-4.1.0&q=85",
    story: "The quiet rhythm of vast grasslands framing a spontaneous promise.",
  },
  {
    id: "eng-3",
    category: "Engagements",
    title: "The Diamond & Cashmere",
    location: "Cotswolds, England",
    aspect: "aspect-[4/3]",
    span: "md:col-span-6",
    url: "https://images.unsplash.com/photo-1522033467113-b8db23657b96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjBlbmdhZ2VtZW50JTIwZW1icmFjZXxlbnwwfHx8fDE3OTAwNTA0OTV8MA&ixlib=rb-4.1.0&q=85",
    story: "Intimate macro details of a bespoke platinum band resting against heirloom knitwear.",
  },
  {
    id: "wed-3",
    category: "Weddings",
    title: "Lakeside Reverie",
    location: "Geneva, Switzerland",
    aspect: "aspect-[4/3]",
    span: "md:col-span-6",
    url: "https://images.unsplash.com/photo-1591604466107-ec97de577aff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwY291cGxlJTIwbHV4dXJ5fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
    story: "Autumnal reflections across tranquil mountain waters and hand-tailored silk.",
  },
  {
    id: "port-2",
    category: "Portraits",
    title: "Ephemeral Tulle In Motion",
    location: "Vienna Opera Quarter, Austria",
    aspect: "aspect-[4/3]",
    span: "md:col-span-6",
    url: "https://images.unsplash.com/photo-1669651970700-9ed6098002d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxlZGl0b3JpYWwlMjBicmlkZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
    story: "Kinetic blur capturing the hypnotic twirl of an artisan cathedral veil.",
  },
  {
    id: "edit-2",
    category: "Editorial",
    title: "Azure Horizon Veil",
    location: "Santorini Caldera, Greece",
    aspect: "aspect-[21/9]",
    span: "md:col-span-12",
    url: "https://images.unsplash.com/photo-1720535874037-baa991defb3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBicmlkZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDA1MDQ5NXww&ixlib=rb-4.1.0&q=85",
    story: "Aegean trade winds lifting gossamer embroidery against endless cobalt horizons.",
  },
];

export const PORTRAIT = {
  url: "https://images.pexels.com/photos/15686835/pexels-photo-15686835.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  alt: "Julian Vance & Clara Moreau editorial portrait",
  caption: "Founders & Principal Directors — Rome, 2024",
};

export const PHILOSOPHIES = [
  "Medium format film & digital hybrid workflow",
  "Maximum twelve commissions accepted per year",
  "Unobtrusive presence, editorial composition",
  "Archival delivery within eight curated weeks",
];

export const PUBLICATIONS = [
  "Vogue Weddings",
  "Over The Moon",
  "Harper's Bazaar",
  "The Lane",
  "Junebug Weddings",
];

export const PACKAGES = [
  {
    tier_id: "the-intimate",
    name: "The Intimate Atelier",
    investment: "$5,800",
    scope: "Elopements & Micro-Celebrations",
    highlights: [
      "Up to 6 Hours Coverage",
      "Julian Vance as Lead Artist",
      "350+ Master Fine-Art Proofs",
      "Private Online Digital Vault",
      "Bespoke Linen Print Folio",
    ],
    option: "The Intimate Atelier ($5,800)",
  },
  {
    tier_id: "the-grand-nuptial",
    name: "The Grand Nuptial",
    badge: "Most Commissioned",
    investment: "$8,900",
    scope: "Full Weekend Wedding Experience",
    highlights: [
      "Up to 10 Hours Seamless Coverage",
      "Both Julian & Clara Dual-Perspective",
      "650+ Master Graded Negatives",
      "Pre-Wedding Editorial Session",
      "Handcrafted Italian Leather Album",
      "Drone Aerial Cine-Stills",
    ],
    option: "The Grand Nuptial ($8,900)",
  },
  {
    tier_id: "the-destination-couture",
    name: "The Destination Couture",
    investment: "$14,500",
    scope: "Multi-Day International Journey",
    highlights: [
      "3 Days Complete Visual Stewardship",
      "Unlimited Worldwide Travel Included",
      "Rehearsal, Nuptials & Day-After Sail",
      "Hand-Bound Master Heirlooms (x3)",
      "Super 8mm Vintage Film Reel Add-on",
      "Private Concierge Archiving",
    ],
    option: "The Destination Couture ($14,500)",
  },
];

export const PACKAGE_OPTIONS = [
  "The Intimate Atelier ($5,800)",
  "The Grand Nuptial ($8,900)",
  "The Destination Couture ($14,500)",
  "Bespoke Multi-Day Commission",
];

export const TESTIMONIALS = [
  {
    quote: "Julian and Clara did not merely document our wedding in Positano; they elevated every fleeting heartbeat into something resembling fine art cinema.",
    author: "Countess Elena & Marcus Sterling",
    venue: "Villa Cimbrone, Ravello",
    date: "September 2025",
  },
  {
    quote: "Looking at our gallery six months later still draws tears. The intimacy, the shadows, the sheer feeling of the day was caught without us ever feeling posed.",
    author: "Dr. Sarah & James Thorne",
    venue: "The Glasshouse, Edinburgh",
    date: "June 2025",
  },
  {
    quote: "They are discrete visual poets. Our families are notoriously camera-shy, yet every portrait radiates effortless confidence and warmth.",
    author: "Amara & Kenji Takahashi",
    venue: "Aman Kyoto, Japan",
    date: "November 2024",
  },
];
